export default __webpack_public_path__ + "static/media/Group 41.77e249d1.svg";